(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.DrvGiftLogic=api;})(typeof window==='undefined'?globalThis:window,function(){
  const fail=message=>{throw new Error(message);};
  const positive=value=>Number.isSafeInteger(value)&&value>0;
  function validateRule(rule,registered){
    if(!rule || !rule.productId || !Array.isArray(rule.gifts))fail('Invalid model configuration');
    if(rule.configured && (!Number.isSafeInteger(rule.selectedCount)||rule.selectedCount<0||rule.selectedCount>8||rule.gifts.length!==rule.selectedCount))fail('Gift references unavailable');
    const seen=new Set();
    for(const gift of rule.gifts){
      if(!registered.includes(String(gift.productId))||seen.has(String(gift.productId)))fail('Unknown or duplicate gift');
      if(String(gift.productId)!==gift.identity||!gift.variantId||gift.unitPrice!==0||gift.available!==true||gift.quantityPerBike!==1)fail('Gift is not ready');
      seen.add(String(gift.productId));
    }
    return rule;
  }
  function plan(state,registered){
    const migratedLegacy=item=>item.legacyGift&&String(item.product_id)==='15715956949158'&&item.original_price===0;
    if(state.items.some(item=>item.legacyGift&&!migratedLegacy(item)))fail("Please remove the previous promotion gift from your cart before continuing.");
    const counts=new Map(),desired=new Map(),updates={},adds=[];
    for(const line of state.items){
      if(!Number.isSafeInteger(line.quantity)||line.quantity<0)fail('Invalid cart quantity');
      if(migratedLegacy(line)){updates[line.key]=0;continue;}
      if(registered.includes(String(line.product_id))||line.managed)continue;
      counts.set(String(line.product_id),(counts.get(String(line.product_id))||0)+line.quantity);
    }
    const models=new Set();
    for(const raw of state.rules){
      const quantity=counts.get(String(raw.productId))||0;
      if(!quantity)continue;
      if(models.has(String(raw.productId)))fail('Duplicate model configuration');
      models.add(String(raw.productId));
      const rule=raw;
      for(const gift of rule.gifts){
        if(!registered.includes(String(gift.productId))||gift.identity!==String(gift.productId)||gift.unitPrice!==0||!gift.variantId)continue;
        const key=String(gift.variantId);
        desired.set(key,(desired.get(key)||0)+quantity);
      }
    }
    for(const [variant,quantity] of desired){
      const waived=state.giftWaivers?.[variant];
      if(Number.isSafeInteger(waived)&&waived>=0)desired.set(variant,Math.max(0,quantity-waived));
      const available=state.rules.some(r=>r.gifts.some(g=>String(g.variantId)===variant&&g.available));
      if(!available){const present=state.items.filter(i=>String(i.variant_id)===variant).reduce((n,i)=>n+i.quantity,0);desired.set(variant,Math.min(desired.get(variant),present));}
    }
    const seen=new Set();
    for(const line of state.items){
      if(!registered.includes(String(line.product_id))&&!line.managed)continue;
      const key=String(line.variant_id),target=seen.has(key)?0:(desired.get(key)||0);
      seen.add(key);
      if(target && line.original_price!==0)fail('A gift price changed');
      if(target!==line.quantity)updates[line.key]=target;
    }
    for(const [variant,quantity] of desired)if(quantity&&!seen.has(variant))adds.push({id:variant,quantity,properties:{_drv_managed_gift:'1'}});
    return {updates,adds};
  }
  function allowances(state,registered){
    const clean={...state,giftWaivers:{},items:state.items.filter(i=>!i.legacyGift)};
    const result={};
    for(const rule of clean.rules){
      const quantity=clean.items.filter(i=>String(i.product_id)===String(rule.productId)).reduce((n,i)=>n+i.quantity,0);
      for(const gift of rule.gifts)if(registered.includes(String(gift.productId)))result[String(gift.variantId)]=(result[String(gift.variantId)]||0)+quantity;
    }
    return result;
  }
  function migrateLimits(state,registered){
    const waivers={...state.giftWaivers},allowed=allowances(state,registered);
    for(const [variant,limit]of Object.entries(state.giftLimits||{}))if(Number.isSafeInteger(limit)&&limit>=0&&waivers[variant]===undefined)waivers[variant]=Math.max(0,(allowed[variant]||0)-limit);
    return waivers;
  }
  function addItems(state,rule,main,accessories,registered){
    validateRule(rule,registered);
    if(!main.id||!positive(main.quantity))fail('Invalid bicycle selection');
    for(const item of accessories)if(!item.id||!positive(item.quantity))fail('Invalid accessory selection');
    const projected={giftWaivers:state.giftWaivers,items:[...state.items,{key:'new-bike',product_id:rule.productId,variant_id:main.id,quantity:main.quantity}],rules:[...state.rules.filter(r=>String(r.productId)!==String(rule.productId)),rule]};
    const change=plan(projected,registered);
    const additions=[...change.adds];
    for(const [key,target] of Object.entries(change.updates)){
      const line=state.items.find(item=>item.key===key);
      if(target>line.quantity)additions.push({id:String(line.variant_id),quantity:target-line.quantity,properties:line.properties||{_drv_managed_gift:'1'}});
    }
    return [main,...accessories,...additions];
  }
  return {validateRule,plan,addItems,allowances,migrateLimits};
});
